module.exports = __webpack_public_path__ + "img/appstore-g.7c118193.svg";